export default class Minter {
  constructor(instance, address) {
    this.address = address;
    this.instance = instance;
  }

  getPublicStartTime() {
    return this.instance.startTimePublic();
  }

  getPublicMintDuration() {
    return this.instance.publicMintDuration();
  }

  getPrice() {
    return this.instance.price();
  }

  getPublicPrice() {
    return this.instance.getPublicMintPrice();
  }

  getSupplyLeft() {
    return this.instance.getSupplyLeft();
  }

  getActiveRound() {
    return this.instance.getActiveRound();
  }

  publicMint(signer, amount, extraData) {
    return this.instance.connect(signer).publicMint(amount, extraData);
  }

  claimMint(signer, amount, proofs) {
    return this.instance.connect(signer).claimMint(proofs, amount);
  }
}
